import React from 'react';

// Значения приходят из справочников бота. Здесь нет словарей товаров и регионов.
export default function AccountOrderItems({ items = [] }) {
  if (!items.length) return null;
  return <ul className="account-order-products">
    {items.map((item, index) => {
      const name = item.productName || '';
      const type = item.productTypeLabel || '';
      const hasDenomination = item.denomination != null && Number.isFinite(Number(item.denomination));
      const currency = item.denominationCurrencyLabel || item.denominationCurrency || '';
      const region = item.regionLabel || item.regionCode || '';
      const structured = Boolean(type || hasDenomination || region || currency);
      if (!structured) return <li key={index} className="account-order-items">
        {name}{item.quantity > 1 ? ` × ${item.quantity}` : ''}
      </li>;

      const denomination = hasDenomination ? `${Number(item.denomination).toLocaleString('ru-RU')} ${currency}`.trim() : '';
      // Только точное совпадение с числом номинала; полные названия сохраняются.
      const numberOnly = hasDenomination && name.trim() === String(item.denomination);
      const titleHasDenomination = hasDenomination && (numberOnly || !name);
      const title = titleHasDenomination ? [type, denomination].filter(Boolean).join(' — ') : name || type;
      const quantity = item.quantity != null && Number.isFinite(Number(item.quantity)) ? item.quantity : null;
      return <li key={index} className="account-order-items">
        {title ? <div>{title}</div> : null}
        <div className="account-order-product-meta">
          {!titleHasDenomination && denomination ? <span>Номинал: {denomination}</span> : null}
          {region ? <span>Регион: {region}</span> : null}
          {quantity != null ? <span>Количество: {quantity}</span> : null}
        </div>
      </li>;
    })}
  </ul>;
}
